<template>
  <div class="t-Popup" v-click-out="handleClickOut">
    <div ref="container" class="t-Popup-content">
      <div ref="shifter" class="t-Popup-slot">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import clickOutDirective from '../../utils/clickoutDirective';

export default {
  directives: {
    ...clickOutDirective,
  },
  methods: {
    handleClickOut() {
      this.$emit('close', false);
    },
    calcShift() {
      const $container = this.$refs.container;
      const $shifter = this.$refs.shifter;

      if ($container && $shifter) {
        const { bottom, right } = $container.getBoundingClientRect();

        let shiftBottom = window.innerHeight - bottom;
        if (shiftBottom < 0) {
          shiftBottom *= -1;
          $shifter.style.bottom = `calc(${shiftBottom}px + var(--track-spacing-md))`;
        } else {
          $shifter.style.bottom = 0;
        }

        let shiftRight = window.innerWidth - right;
        if (shiftRight < 0) {
          shiftRight *= -1;
          $shifter.style.right = `calc(${shiftRight}px + var(--track-spacing-md))`;
        } else {
          $shifter.style.right = 0;
        }
      }
    },
  },
  mounted() {
    this.calcShift();
    window.addEventListener('resize', this.calcShift);
  },
};
</script>

<style lang="scss" scoped>
.t-Popup {
  padding-top: var(--track-spacing-md);
  position: absolute;
  z-index: 999999;
}

.t-Popup-content {
  position: fixed;
}

.t-Popup-slot {
  position: relative;
}
</style>
